module.exports = __webpack_public_path__ + "static/media/360_Desktop6_SV.dbe369af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/360_Desktop6_SV.png
// module id = 563
// module chunks = 0